'use strict'

exports.Connection = require('./connection')



//////////////////
// WEBPACK FOOTER
// ./~/interface-connection/src/index.js
// module id = 13
// module chunks = 0